<template><section><h2>from-textarea</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-form :title="'文本域'" :desc="'输入更多内容的输入区域样式展示'">
    <weui-form-group :title="'问题描述'">
      <weui-textarea v-model="question" placeholder="请描述你所发生的问题" :rows="3" :maxlength="10"></weui-textarea>
    </weui-form-group>
    <weui-form-opr>
      <weui-button @click="save()">确定</weui-button>
    </weui-form-opr>
  </weui-form>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-form :title=&quot;'文本域'&quot; :desc=&quot;'输入更多内容的输入区域样式展示'&quot;&gt;
    &lt;weui-form-group :title=&quot;'问题描述'&quot;&gt;
      &lt;weui-textarea v-model=&quot;question&quot; placeholder=&quot;请描述你所发生的问题&quot; :rows=&quot;3&quot; :maxlength=&quot;10&quot;&gt;&lt;/weui-textarea&gt;
    &lt;/weui-form-group&gt;
    &lt;weui-form-opr&gt;
      &lt;weui-button @click=&quot;save()&quot;&gt;确定&lt;/weui-button&gt;
    &lt;/weui-form-opr&gt;
  &lt;/weui-form&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        question: ''
      }
    },
    methods: {
      save: function() {
        console.log(this.question)
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value(v-model)</td>
<td>输入框内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>placeholder</td>
<td>提示信息</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>rows</td>
<td>输入框行数</td>
<td>number</td>
<td>—</td>
<td>2</td>
</tr>
<tr>
<td>maxlength</td>
<td>最大字符数</td>
<td>number</td>
<td>—</td>
<td>200</td>
</tr>
<tr>
<td>showCount</td>
<td>是否显示计数器</td>
<td>boolean</td>
<td>—</td>
<td>true</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    data() {
      return {
        question: ''
      }
    },
    methods: {
      save: function() {
        console.log(this.question)
      }
    }
  }
</script>